import { Component, OnInit } from '@angular/core';
import { MaterializeDirective } from "angular2-materialize";
import {Router, ActivatedRoute, Params} from '@angular/router';
import { DashboardService } from "./dashboard.service";
import { NotificationsService } from '../shared/notifications.service';
import { Charts } from '../shared/charts';

import {CurrencyPipe} from '@angular/common'

import { SocketService } from '../shared/socket.service';

import * as moment from 'moment';
import * as $ from 'jquery';
import {Observable} from "rxjs"
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  items;
  busy;
  modulesWait: Promise<boolean>;
  revenueGraph;
  pendingOrdersChart;
  confirmedOrdersChart;
  mostFoodGraph;
  mostBeverageGraph;
  mostActiveUser:any=[];
  lastLoginStaff:any=[];

  charts = new Charts;

  isAdmin: any = false;
  permissions: any;


  revenue;
  reservations_count: any;
  latest_reservations: any;
  users_count: any;
  staff_count: any;
  most_food_items: any;
  most_beverage_items: any;

  modules:any;

  Staff_modules:any;
  departments:any;
  durations: any = [
    { key: 0, value: "Today" },
    { key: 1, value: "Yesterday" },
    { key: 7, value: "Last 7 days" },
    { key: 30, value: "Last 30 days" },
    { key: 90, value: "Last 90 days" },
    { key: 364, value: "Last year" },
    { key: "all", value: "All" },
  ];

  duration: number = 7;
  language: any = 'en';

  STATUS: any={
    confirm:"Confirmed",
    cancel:"Cancelled by User",
    pending: "Pending",
    suggestion_by_user: "Changed by User",
    suggestion_by_admin: "Changed by Staff"
  }

  permission:any;
  connection;
  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private klassService: DashboardService,
    private notificationsService: NotificationsService,
    private currencyPipe: CurrencyPipe,
     private socketService: SocketService
  ) { }

  async ngOnInit() {

    this.notificationsService.updateBreadCrumbs([
      { lable:'Email Templates', url:`/email-templates` }
    ]);
console.log('running new build ')
    this.permissions = JSON.parse(localStorage.getItem('permissions'));
    this.isAdmin = localStorage.getItem('isAdmin') === 'true';
    await this.getLocals();

    $("#breadcrumbs").html('<li><a href="/#/"><i class="fa fa-home" aria-hidden="true"></i> Dashboard</a></li>');



      this.connection = this.socketService.getMessages().subscribe(message => {
      this.activatedRoute.params.subscribe((params: Params) => {
        console.log("params=> ",params)
       // if(message['department_id'] === params['activity_log']){     
        this.autoGetItems();
       // }
      })
    })
}

getLocals(){
  this.modules =  JSON.parse(localStorage.getItem('modules'));
  Observable.interval(500)
  .takeWhile(() => this.modules===undefined || this.modules==={} || this.modules===null ||
     this.departments===undefined || this.departments==={} || this.departments===null)
    .subscribe(i => {
    this.modules =  JSON.parse(localStorage.getItem('modules'));
    this.departments = JSON.parse(localStorage.getItem('departments'));

    if(this.modules!==null && this.departments!==null){
      this.modulesWait = Promise.resolve(true);

      this.getItems();
    }
  })
}



autoGetItems() {
    this.items = [];
     this.klassService.getItems(this.language, `viewDashboard/${this.duration}`).then((res) => {

      if(!res)
        return true;

        console.log(res);
      //this.users_count = res.no_of_users;
     // this.staff_count = res.no_of_staff;

      if(this.isAdmin) {
        this.revenue = res.revenue;
        this.reservations_count = res.total_number_of_reservation; //res.number_of_reservation;
        this.latest_reservations = res.top_of_reservation;
        this.most_beverage_items=res.most_beverage_item;
        this.most_food_items=res.most_food_item;
        this.mostActiveUser=res.most_active_user;
        this.lastLoginStaff=res.last_login_staff;
      } else {
        this.revenue = res.revenue.filter(item => this.permissions[item.module_id] && this.permissions[item.module_id].manage_orders);
        this.reservations_count = res.number_of_reservation.filter(item => this.permissions[item._id] && this.permissions[item._id].manage_orders);
        this.latest_reservations = res.top_of_reservation.filter(item => this.permissions[item._id] && this.permissions[item._id].manage_orders);
           

             
      }
      
      let _self=this;
      console.log("_self.modules ,",_self.modules)
      Object.keys(this.modules).forEach(function(key) {
        //console.log("modules===>",this.modules[key])
              if (_self.modules[key] == 'Most Active Users') {
                _self.mostActiveUser=res.most_active_user;

              }
              if (_self.modules[key] == 'Last Staff Logins') {
                _self.lastLoginStaff=res.last_login_staff;
              }
              if (_self.modules[key] == "Guests") {
                _self.users_count = res.no_of_users;
              }
              if (_self.modules[key] == "Staff Members") {
                _self.staff_count = res.no_of_staff;
              }
            });  
  
      this.createOrdersChart();
      this.createRevenueGraph();
      this.createFoodGraph();
      this.createBeveragesGraph();

    });
  }
  getItems() {
    this.items = [];
    this.busy = this.klassService.getItems(this.language, `viewDashboard/${this.duration}`).then((res) => {

      if(!res)
        return true;

        console.log(res);
      //this.users_count = res.no_of_users;
     // this.staff_count = res.no_of_staff;

      if(this.isAdmin) {
        this.revenue = res.revenue;
        this.reservations_count = res.total_number_of_reservation; //res.number_of_reservation;
        this.latest_reservations = res.top_of_reservation;
        this.most_beverage_items=res.most_beverage_item;
        this.most_food_items=res.most_food_item;
        this.mostActiveUser=res.most_active_user;
        this.lastLoginStaff=res.last_login_staff;
      } else {
        this.revenue = res.revenue.filter(item => this.permissions[item.module_id] && this.permissions[item.module_id].manage_orders);
        this.reservations_count = res.number_of_reservation.filter(item => this.permissions[item._id] && this.permissions[item._id].manage_orders);
        this.latest_reservations = res.top_of_reservation.filter(item => this.permissions[item._id] && this.permissions[item._id].manage_orders);
           

             
      }
      
      let _self=this;
      console.log("_self.modules ,",_self.modules)
      Object.keys(this.modules).forEach(function(key) {
        //console.log("modules===>",this.modules[key])
              if (_self.modules[key] == 'Most Active Users') {
                _self.mostActiveUser=res.most_active_user;

              }
              if (_self.modules[key] == 'Last Staff Logins') {
                _self.lastLoginStaff=res.last_login_staff;
              }
              if (_self.modules[key] == "Guests") {
                _self.users_count = res.no_of_users;
              }
              if (_self.modules[key] == "Staff Members") {
                _self.staff_count = res.no_of_staff;
              }
            });  
  
      this.createOrdersChart();
      this.createRevenueGraph();
      this.createFoodGraph();
      this.createBeveragesGraph();

    });
  }

  formatDate(dateTime, time) {
    if(dateTime){
     let date = dateTime.split('T')[0];
      if (time) {
        let time = dateTime.split('T')[1];
        return moment(date).format('MM/DD/YYYY') +' '+  moment(time, ["HH:mm:ss"]).format("hh:mm A");
      }else{
        return moment(date).format('MM/DD/YYYY')
      }
    }
  }

  createOrdersChart() {
    let totalCounts = 0;
    let obj = {
      title: 'All Orders ',
      tooltip: '{series.name}: <b> {point.y} ({point.percentage:.1f}%)</b>',
      label: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)',
      data: [{
          name: 'Orders',
          data: []
      }]
    }
    this.reservations_count.forEach(item => {
      totalCounts += item.count;
      obj.data[0].data.push({ name: this.modules[item._id], y:  item.count })
    })
    obj.title += `(${totalCounts})`
    if(this.reservations_count.length>0)
    this.confirmedOrdersChart = this.charts.pieChart(obj);
  }

  createRevenueGraph() {
    let totalRevenue = 0;
    let obj = {
      title: 'Revenue ',
      tooltip: '{series.name}: <b>  ${point.y}  ({point.percentage:.1f}%)</b>',
      label: '<b>{point.name}</b>:  ${point.y} ({point.percentage:.1f}%)' ,
      data: [{
          name: 'Orders',
          data: []
      }]
    }

    this.revenue.forEach(item => {
      totalRevenue += item.revenue;
      obj.data[0].data.push({ name: this.modules[item.module_id], y:  item.revenue })
    })
    obj.title += `(${this.currencyPipe.transform(totalRevenue, 'USD' , true, '1.0-0')})`;
    if(totalRevenue>0)
    this.revenueGraph = this.charts.pieChart(obj);

  }

  createFoodGraph() {

    let obj = {
      title: 'Most Ordered Food  Items',
      tooltip: '{series.name}: <b>({point.percentage:.1f}%)</b>',
      label: '<b>{point.name}</b>: ${point.y} ({point.percentage:.1f}%)',
      data:[]
    }

    let xAxis=[];

    this.most_food_items.forEach(item => {
      xAxis.push(item._id.item);
      obj.data.push({ name: item._id.item, data:  [item.count] })
    })
    //obj.title += `($${totalRevenue})`
    if(this.most_food_items.length>0)
    this.mostFoodGraph = this.charts.barGraph(obj,xAxis);
  }
  createBeveragesGraph() {

    let obj = {
      title: 'Most Ordered Beverage  Items',
      tooltip: '{series.name}: <b>({point.percentage:.1f}%)</b>',
      label: '<b>{point.name}</b>: ${point.y}({point.percentage:.1f}%)',
      data:[]
    }

    let xAxis=[];

    this.most_beverage_items.forEach(item => {
      xAxis.push(item._id.item);
      obj.data.push({ name: item._id.item, data:  [item.count] })
    })
    //obj.title += `($${totalRevenue})`
    if(this.most_beverage_items.length>0)
    this.mostBeverageGraph = this.charts.barGraph(obj,xAxis);
  }

  labelClass(status){
    //customize accordingly
    if(status){
      if(status === 'Confirmed')return 'label-success';
      if(status === 'Pending')return 'label-danger';
      if(status === 'Changed by User')return 'label-warning';
      if(status === 'Cancelled by User')return 'label-default';
      if(status === 'Changed by Staff')return 'label-info';
      // if(status === 'Confirmed')return 'label-primary';
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/dashboard/dashboard.component.ts